export default __webpack_public_path__ + "static/796-e10acbb81b86de51300653503db71b99.gif";